<template>
  <WhiteIQOS
    bodyClass="billing-emails-body"
    :title="$t('billing_reminders_panel.title')"
    :subtitle="$t('billing_reminders_panel.subtitle')"
  >
    <div class="qrw-label-md bold">
      {{$t('billing_reminders_panel.list')}}
    </div>
    <div class="gap-row-xs">
      <div class="email-row">
        <div class="row-number">
          {{ 1 }}
        </div>
        <BaseTextInput
          type="email"
          v-model="owner.email"
          disabled
          placeholder="Email"
          size="md"
        />
        <BaseIconButton
          icon="x"
          size="md"
          variant="ghost"
          :disabled="true"
          textColor="content-base-secondary"
        />
      </div>
      <div
        class="email-row"
        v-for="(email,index) in emails"
        :key="index"
      >
        <div class="row-number">
          {{ index + 2}}
        </div>
        <BaseTextInput
          type="email"
          v-model="emails[index]"
          @blur="save"
          placeholder="Email"
          size="md"
        />
        <BaseIconButton
          icon="x"
          size="md"
          variant="ghost"
          @click="removeEmail(index)"
          :disabled="emails.length == 1"
          textColor="content-base-secondary"
        />
      </div>
    </div>

    <BasePushButton
      icon="plus"
      variant="ghost"
      @click="emails.push('')"
      :disabled="emails.length >= 4"
      size="md"
      textColor="content-base-secondary"
    >
      {{$t('billing_reminders_panel.add')}}
    </BasePushButton>
  </WhiteIQOS>
</template>

<script>
import SuperbillingAPI from '@/api/superbilling'

export default {
  data() {
    return {
      emails: []
    }
  },
  methods: {
    removeEmail(index) {
      this.emails.splice(index, 1)
      this.save()
    },
    save() {
      const billing = {
        ...this.$store.state.cafe.billing,
        notification_emails: this.emails
      }

      this.$store.commit('patchCafeGeneralData', {
        billing
      })

      SuperbillingAPI.updateSettings(this.$store.state.cafe._id, {
        notification_emails: this.emails
      })
        .then(data => {
          //nothing
        })
        .catch(err => {
          consol.error(err)
        })
    }
  },
  computed: {
    owner() {
      return this.$store.state.owner
    }
  },
  mounted() {
    const billing = this.$store.state.cafe.billing

    if (billing && billing.notification_emails) {
      this.emails = billing.notification_emails
    }
  }
}
</script>

<style scoped>
.email-row {
  background: var(--qrw-background-base-tertiary);
  border-radius: 10px;
  display: flex;
}

.row-number {
  display: flex;
  color: var(--qrw-content-base-secondary);
  box-sizing: border-box;
  padding: 10px;
  align-items: center;
  justify-content: center;
}
</style>

<style>
.billing-emails-body {
  padding: 24px !important;
  flex-direction: column;
  row-gap: 24px;
  display: flex;
}
</style>